import { render, staticRenderFns } from "./FriendLinks.vue?vue&type=template&id=43024d04&scoped=true&"
import script from "./FriendLinks.vue?vue&type=script&lang=js&"
export * from "./FriendLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43024d04",
  null
  
)

export default component.exports